import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
export default styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 14rem;\n  font-style: italic;\n  color: ", ";\n  margin: 0;\n  padding: 0;\n"])), function (props) {
  return props.color;
});